import request from '@/http/request';

// 获取Dcops搬迁看板园区选项
export function getDcopsMoveCampusOptions() {
  return request({
    url: '/api/v1/ops/dcops_move_campus_options',
    method: 'get',
  });
}

// 获取Dcops搬迁看板统计数据
export function getDcopsMoveBoardStatistics(data) {
  return request({
    url: '/api/v1/ops/dcops_move_board_statistics',
    method: 'post',
    data,
  });
}

// 获取Dcops搬迁告警工单列表
export function getDcopsMoveAlertTickets(data) {
  return request({
    url: '/api/v1/ops/dcops_move_alert_tickets',
    method: 'post',
    data,
  });
}

// 搬迁告警工单结单（逻辑删除）
export function dismissDcopsMoveAlertTicket(data) {
  return request({
    url: '/api/v1/ops/dcops_move_alert_dismiss',
    method: 'post',
    data,
  });
}

// 获取Dcops搬迁超时工单列表
export function getDcopsMoveOvertimeTickets(data) {
  return request({
    url: '/api/v1/ops/dcops_move_overtime_tickets',
    method: 'post',
    data,
  });
}

// 获取Dcops故障看板统计数据
export function getDcopsFaultBoardStatistics(data) {
  return request({
    url: '/api/v1/ops/dcops_fault_board_statistics',
    method: 'post',
    data,
  });
}

// 获取Dcops故障超时工单列表
export function getDcopsFaultOvertimeTickets(data) {
  return request({
    url: '/api/v1/ops/dcops_fault_overtime_tickets',
    method: 'post',
    data,
  });
}

// 获取Dcops故障告警工单列表
export function getDcopsFaultAlertTickets(data) {
  return request({
    url: '/api/v1/ops/dcops_fault_alert_tickets',
    method: 'post',
    data,
  });
}
